import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

const refactorHBData = (data, key, handlebars) => {

  const hbars = handlebars !== undefined ? handlebars : true

  const keyItem = key ? key : 'shb'

  const short = (data[`${keyItem}ImageStyle`] && data[`${keyItem}ImageStyle`].toLowerCase() === 'short') ? true : false;

  var imgData;

  if (data[`${keyItem}BannerImage`]) {
    imgData = data[`${keyItem}BannerImage`];
  } else if (data[`${keyItem}Image`]) {
    imgData = data[`${keyItem}Image`];
  }

  const img = imgData ? refactorRespImg(imgData, [{
    size: 'default',
    key: short ? 'image_size_840x220' : 'image_size_840x350'
  },{
    size: 'md',
    key: short ? 'image_size_1280x336' : 'image_size_1280x640',
  },{
    size: 'lg',
    key: short ? 'image_size_1600x420' : 'image_size_1600x800',
  }]) : null;

  const ctas = [{
    href: get(data, `${keyItem}Cta.url`, null),
    title: get(data, `${keyItem}Cta.title`, null),
    target: get(data, `${keyItem}Cta.target`, null),
  }];

  var type;
  if (data[`${keyItem}ImageStyle`] && data[`${keyItem}ImageStyle`].toLowerCase() === 'short') {
    type = 'smallBanner'
  } else if (data[`${keyItem}ImageStyle`] && data[`${keyItem}ImageStyle`].toLowerCase() === 'medium') {
    type = 'mediumBanner'
  } else {
    type = 'largeBanner'
  }


  const handleBarItem = `
    'mainHeading': '{{data.mainHeading}}',
    'subHeading1': '{{data.subHeading1}}',
    'subHeading2': '{{data.subHeading2}}',
    'type': '{{data.type}}',
    'bgVideoDesktop': "{{json data.bgVideoDesktop}}",
    'bgVideoMobile': '{{json data.bgVideoMobile}}',
    'bgImg': '{{json data.bgImg}}',
    'ctas': '{{json data.ctas}}'
  `.replace(/\\"/g, '"').replace(/(\r\n|\n|\r)/gm, "").replace(/\n/g,'').replace(/'/g,'"').replace(/\\/g, '').trim()

  // console.log('TEST', handleBarItem.replace(/\\"/g, '"').replace(/(\r\n|\n|\r)/gm, ""))
  

  return {
  // return process.env.DEALER_SITE && hbars ? handleBarItem : {
    mainHeading: data[`${keyItem}HeadingText`] || null,
    subHeading1: data[`${keyItem}Subheading1Text`] || null,
    subHeading2: data[`${keyItem}Subheading2Text`] || null,
    type: type, //smallBanner, mediumBanner or largeBanner
    bgVideoMobile: {
      src: get(data, `${keyItem}VideoMobile.guid`, null),
      mimeType: get(data, `${keyItem}VideoMobile.mimeType`, null),
      id: get(data, `${keyItem}VideoMobile.id`, null)
    },
    bgVideoDesktop: {
      src: get(data, `${keyItem}VideoDesktop.guid`, null),
      mimeType: get(data, `${keyItem}VideoDesktop.mimeType`, null),
      id: get(data, `${keyItem}VideoMobile.id`, null)
    },
    bgImage: img,
    ctas: ctas[0].href ? ctas : []
  }
}

export default refactorHBData